import { Component, OnInit } from '@angular/core';
import { Datospregunta } from 'src/app/modelos/datos/datospregunta.model';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
///variable de jquey para modal//
declare var $: any;
@Component({
  selector: 'app-editorcuestionario',
  templateUrl: './editorcuestionario.component.html',
  styleUrls: ['./editorcuestionario.component.css']
})
export class EditorcuestionarioComponent implements OnInit {
  public titulo: string = "";
  public descripcion: string = "";
  public contador = [

  ];
  public preguntas:Array<Datospregunta>=[];
  constructor(private servicio:ServicioFirebaseService) { }

  ngOnInit() {
  }
  agregarPregunta() {
    this.contador.push("pregunta");
  }
  eliminarPregunta(i: number) {
    this.contador.splice(i, 1);
  }
  RegistrarActividad() {
    
  }
  registrarActividad() {
    for (var i = 1; i <= this.contador.length; i++) {
      var pregunta = document.forms[i.toString()].getElementsByTagName("input")[0].value
      var respuesta = document.forms[i.toString()].getElementsByTagName("input")[1].value
      var distractor1 = document.forms[i.toString()].getElementsByTagName("input")[2].value
      var distractor2 = document.forms[i.toString()].getElementsByTagName("input")[3].value
      var distractor3 = document.forms[i.toString()].getElementsByTagName("input")[4].value
      pregunta={
        pregunta:pregunta,
        respuestaCorrecta:respuesta,
        distractores:[distractor1,distractor2,distractor3],
      }
      this.preguntas.push(pregunta);
    }
    this.servicio.afAuth.authState.subscribe(res => {
      if (res) { 
       this.servicio.crearNuevaActividadCuestionario(res.uid,"cuestionario",this.titulo,this.descripcion,this.preguntas).then(res=>{
        this.showModal();
       })
      }
    });
  }
  showModal():void {
    $("#myModal").modal('show');
  }

  


}
